import { Stack, Typography } from '@mui/material';
import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	RenewalData,
	withRenewalContext,
} from '../../../context/RenewalProvider';
import { capitalize } from '../../../util/util';
import { StyledSectionContainer } from '../../common';
import DisplayCard from '../../DisplayCard';
import {
	DATE_PRECISION,
	DATE_PRECISION_INPUT_FORMAT,
} from '../../fastForm/data/constants';

interface Props {
	authData: AuthData;
	renewalData: RenewalData;
}

/**
 * The overview page for an renewal
 */
const Overview = (props: Props) => {
	const { renewalData, authData } = props;
	const { renewalUpdateObj, renewalResponse } = renewalData;
	if (!renewalUpdateObj) {
		return null;
	}

	const renderDetailCard = (title: string, data: string) => {
		return <DisplayCard title={title} value={data} />;
	};

	return (
		<StyledSectionContainer>
			<Stack spacing={2}>
				<Typography id='renewal_id' variant='h3' gutterBottom>
					{`Renewal ${renewalUpdateObj.locator}`}
				</Typography>
				<Stack spacing={2} direction='row'>
					{renderDetailCard(
						'Created',
						authData.getFormattedDate(
							renewalUpdateObj?.createdTimestamp?.toString(),
						),
					)}
					{renderDetailCard(
						'Renewal End Date',
						authData.getFormattedDate(
							renewalUpdateObj?.renewalEndTimestamp?.toString(),
						),
					)}
					{renderDetailCard(
						'Last Updated',
						authData.getFormattedDate(
							renewalUpdateObj?.updatedTimestamp?.toString(),
						),
					)}
					{renderDetailCard('State', capitalize(renewalUpdateObj.state))}
					{renewalResponse?.resourcesAsOfTimestamp &&
						renderDetailCard(
							'Resource Group',
							`${authData.getZonedFormattedDateString(
								renewalResponse.resourcesAsOfTimestamp,
								DATE_PRECISION_INPUT_FORMAT[DATE_PRECISION.MINUTE],
							)} ${
								renewalResponse?.overrideResourcesAsOfTimestamp
									? ' (Override)'
									: ''
							}`,
						)}
				</Stack>
			</Stack>
		</StyledSectionContainer>
	);
};

export default withRenewalContext<Props>(Overview);
